import { createSDK } from "./create";
import { getDeviceInfo } from "./device-detection";
import { sortQueue } from "./sort-queue";

const sdk = createSDK({
	device: getDeviceInfo(),
});

const stub = window.nubeSDK;

if (stub?.queue) {
	const sorted = stub.queue.sort(sortQueue);

	for (const [method, ...args] of sorted)
		Reflect.apply(sdk[method as "on" | "off" | "send"], sdk, args);
}

// Mutate the stub in-place so any consumer that captured `window.nubeSDK`
// before the swap (e.g. via useState in a hook effect) keeps a working
// reference. Otherwise listeners registered on the stub after the queue
// has been drained are lost.
if (stub) {
	Object.assign(stub, sdk);
	stub.queue = undefined;
	window.nubeSDK = stub;
} else {
	window.nubeSDK = sdk;
}
